import { connectFirestoreEmulator, Firestore, getFirestore } from 'firebase/firestore'

import { railsContext } from 'Const'

import { app } from './app'

let instance: Firestore
const firestore = (): Firestore => {
  if (instance) return instance

  let databaseId = '(default)'
  let emulator: [host: string, port: number] | false = false

  if ('firestoreConfig' in railsContext) {
    const { firestoreConfig } = railsContext
    databaseId = firestoreConfig.databaseId
    if (typeof firestoreConfig.emulator == 'string') {
      const [host, port] = firestoreConfig.emulator.split(':')
      emulator = [host, +port]
    }
  }

  instance = getFirestore(app(), databaseId)
  if (emulator) {
    connectFirestoreEmulator(instance, ...emulator)
  }

  return instance
}

export { firestore }
